import React, { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';

/**
 * Small dot + trailing ring cursor that stays visible on desktop and
 * reacts to elements marked with data-cursor="hover".
 */
export default function CustomCursor() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const [enabled, setEnabled] = useState(true);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const isTouch = window.matchMedia('(pointer: coarse)').matches;
    if (isTouch) {
      setEnabled(false);
      return undefined;
    }

    const dot = dotRef.current;
    const ring = ringRef.current;
    if (!dot || !ring) return undefined;

    document.documentElement.style.cursor = 'none';

    const move = (event) => {
      gsap.to(dot, {
        x: event.clientX,
        y: event.clientY,
        duration: 0.05,
        overwrite: 'auto',
      });
      gsap.to(ring, {
        x: event.clientX,
        y: event.clientY,
        duration: 0.18,
        overwrite: 'auto',
      });
    };

    const grow = () => {
      gsap.to(ring, { scale: 2.1, duration: 0.2, opacity: 0.55, overwrite: 'auto' });
    };

    const shrink = () => {
      gsap.to(ring, { scale: 1, duration: 0.2, opacity: 1, overwrite: 'auto' });
    };

    const attachHoverListeners = () => {
      document.querySelectorAll('[data-cursor="hover"]').forEach((node) => {
        node.addEventListener('mouseenter', grow);
        node.addEventListener('mouseleave', shrink);
      });
    };

    window.addEventListener('mousemove', move);
    attachHoverListeners();

    const rescan = window.setInterval(attachHoverListeners, 1500);

    return () => {
      window.removeEventListener('mousemove', move);
      window.clearInterval(rescan);
      document.documentElement.style.cursor = '';
    };
  }, []);

  if (!enabled) return null;

  return (
    <>
      <div
        ref={dotRef}
        style={{
          position: 'fixed',
          inset: 0,
          width: 8,
          height: 8,
          marginLeft: -4,
          marginTop: -4,
          borderRadius: '50%',
          background: '#818cf8',
          pointerEvents: 'none',
          zIndex: 9999,
          transform: 'translate3d(0, 0, 0)',
          boxShadow: '0 0 0 1px rgba(255,255,255,0.1)',
          willChange: 'transform',
        }}
      />
      <div
        ref={ringRef}
        style={{
          position: 'fixed',
          inset: 0,
          width: 36,
          height: 36,
          marginLeft: -18,
          marginTop: -18,
          borderRadius: '50%',
          border: '1px solid rgba(129,140,248,0.7)',
          pointerEvents: 'none',
          zIndex: 9998,
          transform: 'translate3d(0, 0, 0)',
          opacity: 1,
          willChange: 'transform, opacity',
        }}
      />
    </>
  );
}
